import React, { useState, useEffect, useMemo } from 'react'
import api from '../components/api'
import { rotulo, rotuloEnviado, sleep, corEnviado, cor, corCertificado } from '../components/functions'
import { useHistory } from 'react-router-dom'
//import { MDBDataTableV5 } from 'mdbreact';
import ModalCompras from '../modals/compras'
import LoaderIcon from "react-loader-icon";

import ModalValidacao from '../modals/validacao'
import ModalEmailCorrecao from '../modals/emailCorrecao'

import MaterialReactTable from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';

import { useVerificaDesafioContext } from '../context/verificaDesafioContext'

import Pendencias from '../components/Pendencias'

import ModalEmailVer from '../modals/emailVer'
import { useEmailVerContext } from '../context/emailVerContext'


import "@fortawesome/fontawesome-free/css/all.min.css";
import Badge from 'react-bootstrap/Badge';

const Compras = () => {

    const history = useHistory()

    const { verificaDesafio, setVerificaDesafio } = useVerificaDesafioContext()
    const { desafioEmail_id, setDesafioEmail_id } = useEmailVerContext()

    const [carregando, setCarregando] = useState('block')

    var [compras_id, setCompras_id] = useState()
    var [resultado, setResultado] = useState([])
    

    var [resultadoRede, setResultadoRede] = useState()
    var [resultadoPend, setResultadoPend] = useState([])

    var [adesao_institucional_id, setAdesaoInstitucionalId] = useState()

    var [ano, setAno] = useState(new Date().getFullYear() -1)
    var [anoProps, setAnoProps] = useState()
    var [anos, setAnos] = useState()
    var [adesao_institucional_id_ref, setAdesaoInstitucionalIdRef] = useState(0)

    var [resultadoCorrecoes, setResultadoCorrecoes] = useState([])
    var [totalCorrecoes, setTotalCorrecoes] = useState(0)
    var [totalPreenchimentos, setTotalPreenchimentos] = useState(0)



    const [uf, setUF] = useState('')
    const [resultadoUF, setResultadoUF] = useState([])
    const [regiao, setRegiao] = useState('')
    const [resultadoRegiao, setResultadoRegiao] = useState([])
    const [totalAdesoes, setTotalAdesoes] = useState(0)


    const [totalVerificados, setTotalVerificados] = useState(0)
    const [resultadoVerificados, setResultadoVerificados] = useState([])
    const [totalNotificacoes, setTotalNotificacoes] = useState(0)

    /*
    const data = {
        columns: [

          
          
          {
            label: 'Nome Fantasia',
            field: 'nome_fantasia',
            sort: 'asc',
            width: 270
          },
          {
            label: 'CNPJ',
            field: 'cnpj',
            sort: 'asc',
            width: 200
          },
          {
            label: 'Ano',
            field: 'anoDesafio',
            sort: 'asc',
            width: 100
          },
          
          {
            label: 'Seção I',
            field: 'secaoI',
            sort: 'asc',
            width: 100
          },

          {
            label: 'Seção II',
            field: 'secaoII',
            sort: 'asc',
            width: 100
          },

          {
            label: 'Seção III',
            field: 'secaoIII',
            sort: 'asc',
            width: 100
          },

          {
            label: 'Seção IV',
            field: 'secaoIV',
            sort: 'asc',
            width: 100
          },

          {
            label: 'Situação',
            field: 'situacaoEnviado',
            sort: 'asc',
            width: 100
          },
          
          {
            label: 'Enviado em',
            field: 'dataEnvio',
            sort: 'asc',
            width: 100
          },

        ],

        rows: resultadoPend
    }
    */



    /*

        <table id="tabelaCompras" className="table table-bordered table-striped table-hover">
        <thead>
            <tr>
                <th>Nome Fantasia</th>
                <th><center>CNPJ</center></th>
                
                <th><center>Último ano</center></th>
                <th><center>Data último preenchimento</center></th>
                <th><center>Adesão em</center></th>
                
                
            </tr>
        </thead>
        <tbody>
            {resultado}
        </tbody>
        
    </table>


    <tr style={{ cursor: 'pointer'}} onClick={() => history.push(`DesafioCompras/${rs.adesao_institucional_id}`)}>
                        <td>
                            {rs.nome_fantasia}
                        </td>
                        <td>
                            <center>{rs.cnpj}</center>
                        </td>
                       
                        <td>
                            <center>
                            {rs.ultimoAnoInformado}
                            </center>
                        </td>
                        <td>
                            <center>
                            {rs.dataUltimoPreenchimento}
                            </center>
                        </td>
                        <td>
                            <center>
                           {rs.dataAdesao}
                           </center>
                        </td>
                        
                    </tr>
                

    */





    const columnsR = useMemo(
        () => [
          {
            accessorKey: 'nome_fantasia', //access nested data with dot notation
            header: 'Nome Fantasia',
          },
          {
            accessorKey: 'cnpj',
            header: 'CNPJ',
          },
          {
            accessorKey: 'ultimoAnoInformado',
            header: 'Último ano',
          },

          {
            accessorKey: 'dataUltimoPreenchimento',
            header: 'Data último preenchimento',
          },

          {
            accessorKey: 'dataAdesao',
            header: 'Data Adesão',
          },

        ],
        [],
      );


      const columnsVerificados = useMemo(
        () => [
          {
            accessorKey: 'nome_fantasia', //access nested data with dot notation
            header: 'Nome Fantasia',
          },
          {
            accessorKey: 'cnpj',
            header: 'CNPJ',
          },
          {
            accessorKey: 'anoDesafio',
            header: 'Ano',
          },

          {
            accessorKey: 'certificacao',
            header: 'Reconhecimento',
            Cell: ({ renderedCellValue, row }) => (
            
                //<span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : 'primary' }`}>{rotulo(renderedCellValue)}</span>
                <Badge style={{  backgroundColor: corCertificado(renderedCellValue) }}>{renderedCellValue}</Badge>
           
            ),
          },
         

        ],
        [],
      );


    const columnsCorrecoes = useMemo(
        () => [
          {
            accessorKey: 'nome_fantasia', //access nested data with dot notation
            header: 'Nome Fantasia',
          },
          {
            accessorKey: 'cnpj',
            header: 'CNPJ',
          },
          {
            accessorKey: 'anoDesafio',
            header: 'Ano',
          },

          {
            accessorKey: 'uf_codigo',
            header: 'UF',
          },

          {
            accessorKey: 'situacaoPerfilAnual',
            header: 'Perfil Anual',
            Cell: ({ renderedCellValue, row }) => (
            
                //<span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : 'primary' }`}>{rotulo(renderedCellValue)}</span>
                <Badge style={{  backgroundColor: cor(renderedCellValue) }}>{rotulo(renderedCellValue)}</Badge>
           
              ),
          },

          {
            accessorKey: 'secaoI',
            header: 'Seção I',
            Cell: ({ renderedCellValue, row }) => (
            
                //<span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : 'primary' }`}>{rotulo(renderedCellValue)}</span>
                <Badge style={{  backgroundColor: cor(renderedCellValue) }}>{rotulo(renderedCellValue)}</Badge>
           
              ),
          },

          {
            accessorKey: 'secaoII',
            header: 'Seção II',
            Cell: ({ renderedCellValue, row }) => (
            
                //<span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : 'primary' }`}>{rotulo(renderedCellValue)}</span>
                <Badge style={{  backgroundColor: cor(renderedCellValue) }}>{rotulo(renderedCellValue)}</Badge>
           
              ),
          },

          {
            accessorKey: 'secaoIII',
            header: 'Seção III',
            Cell: ({ renderedCellValue, row }) => (
            
                //<span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : 'primary' }`}>{rotulo(renderedCellValue)}</span>
                <Badge style={{  backgroundColor: cor(renderedCellValue) }}>{rotulo(renderedCellValue)}</Badge>
           
              ),
          },

          {
            accessorKey: 'secaoIV',
            header: 'Seção IV',
            Cell: ({ renderedCellValue, row }) => (
            
                //<span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : 'primary' }`}>{rotulo(renderedCellValue)}</span>
                <Badge style={{  backgroundColor: cor(renderedCellValue) }}>{rotulo(renderedCellValue)}</Badge>
           
              ),
          },

          {
            accessorKey: 'situacaoEnviado',
            header: 'Situação',
            Cell: ({ renderedCellValue, row }) => (
            
                //<span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'A' ? 'warning' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : 'primary' }`}>{rotuloEnviado(renderedCellValue)}</span>
                //<Badge style={{  backgroundColor: renderedCellValue == 'P' ? '#ffc4ab' : renderedCellValue == 'S' || renderedCellValue == null  ? '#7edeed' : renderedCellValue == 'A' ? '#ebe7b2' : renderedCellValue == 'V' ? '#59d970' : '#003366'  }}>{rotuloEnviado(renderedCellValue)}</Badge>
                <Badge style={{  backgroundColor: corEnviado(renderedCellValue) }}>{rotuloEnviado(renderedCellValue)}</Badge>
           
            ),
          },

         

        ],
        [],
      );



    async function carregaRede() {

        await api.get(`adesaoInstitucionalRede`).then((result) => {

            setResultadoRede(result.data.map((rs) =>

                <option value={rs.adesao_institucional_id} key={rs.adesao_institucional_id}>{rs.razao_social}</option>
            
            ))

        })

    }

    /*
    async function geraExcelPend() {

        window.toastr.success('Aguarde, gerando XLSX...')

        var url = `geraExcelComprasPend/${adesao_institucional_id_ref}/${ano}`
        //console.log(url)

        

        await api.get(url).then((result) => {


            if (result.data.alerta == 'ok') {


                sleep(1000).then(() => {

                    //window.location.href = `http://apihomolog.hospitaissaudaveis.org/residuosSS.xlsx`
                    window.location.href = `${process.env.REACT_APP_API}/${result.data.arquivo}`

                })
                
            }

        }).catch((err) => {

            console.log(err.response)

        })

    }
    */


    const geraExcelPend = async () => {

        window.toastr.info("Aguarde...");

        try {

        const response = await api.get(`geraExcelComprasPend/${adesao_institucional_id_ref}/${ano}`, {
            responseType: "blob",
            validateStatus: (status) => true // para não cair direto no catch
        });

        if (response.status !== 200) {
            // ler como texto para ver o erro real
            const errorText = await response.data.text();
            console.error("Erro backend:", errorText);
            window.toastr.error("Erro ao exportar: " + errorText);
            return;
        }

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "compras.xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        window.toastr.success("Download concluído!");
        } catch (err) {
        console.error(err);
        window.toastr.error("Falha ao baixar arquivo");
        }
    };



    async function carregaDados() {


            await api.get('comprasLista').then((result) => {

                //console.log(result.data)

                setTotalAdesoes(result.data.length)
                setResultado(result.data)

                /*
                setResultado(result.data.map((rs) =>
                
                    <tr style={{ cursor: 'pointer'}} onClick={() => history.push(`DesafioCompras/${rs.adesao_institucional_id}`)}>
                        <td>
                            {rs.nome_fantasia}
                        </td>
                        <td>
                            <center>{rs.cnpj}</center>
                        </td>
                       
                        <td>
                            <center>
                            {rs.ultimoAnoInformado}
                            </center>
                        </td>
                        <td>
                            <center>
                            {rs.dataUltimoPreenchimento}
                            </center>
                        </td>
                        <td>
                            <center>
                           {rs.dataAdesao}
                           </center>
                        </td>
                        
                    </tr>
                
                ))
                */

            }).catch((err) => {

                console.log(err.response)

            })


        //dataTableRender('tabelaCompras', 0, 'asc')

    }



    const columns = useMemo(
        () => [
          {
            accessorKey: 'nome_fantasia', //access nested data with dot notation
            header: 'Nome Fantasia',
          },
          {
            accessorKey: 'cnpj',
            header: 'CNPJ',
          },
          {
            accessorKey: 'anoDesafio',
            header: 'Ano',
          },
          {
            accessorKey: 'uf_codigo',
            header: 'UF',
          },

          {
            accessorKey: 'situacaoPerfilAnual',
            header: 'Perfil Anual',
            Cell: ({ renderedCellValue, row }) => (
            
                //<span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : 'primary' }`}>{rotulo(renderedCellValue)}</span>
                <Badge style={{  backgroundColor: cor(renderedCellValue) }}>{rotulo(renderedCellValue)}</Badge>
           
            ),
          },

          {
            accessorKey: 'dataAdesao',
            header: 'Adesão',
          },


          {
            accessorKey: 'secaoI',
            header: 'Seção I',
            Cell: ({ renderedCellValue, row }) => (
            
                //<span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : 'primary' }`}>{rotulo(renderedCellValue)}</span>
                <Badge style={{  backgroundColor: cor(renderedCellValue) }}>{rotulo(renderedCellValue)}</Badge>
           
              ),
          },

          {
            accessorKey: 'secaoII',
            header: 'Seção II',
            Cell: ({ renderedCellValue, row }) => (
            
                //<span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : 'primary' }`}>{rotulo(renderedCellValue)}</span>
                <Badge style={{  backgroundColor: cor(renderedCellValue) }}>{rotulo(renderedCellValue)}</Badge>
           
              ),
          },

          {
            accessorKey: 'secaoIII',
            header: 'Seção III',
            Cell: ({ renderedCellValue, row }) => (
            
                //<span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : 'primary' }`}>{rotulo(renderedCellValue)}</span>
                <Badge style={{  backgroundColor: cor(renderedCellValue) }}>{rotulo(renderedCellValue)}</Badge>
           
              ),
          },

          {
            accessorKey: 'secaoIV',
            header: 'Seção IV',
            Cell: ({ renderedCellValue, row }) => (
            
                //<span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : 'primary' }`}>{rotulo(renderedCellValue)}</span>
                <Badge style={{  backgroundColor: cor(renderedCellValue) }}>{rotulo(renderedCellValue)}</Badge>
           
              ),
          },


          {
            accessorKey: 'dataAdesao',
            header: 'Adesão',
          },

          {
            accessorKey: 'situacaoEnviado',
            header: 'Situação',
            Cell: ({ renderedCellValue, row }) => (
            
                //<span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'A' ? 'warning' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : renderedCellValue == null || renderedCellValue == 'P' ? 'danger' : 'warning' }`}>{rotuloEnviado(renderedCellValue)}</span>
                //<Badge style={{  backgroundColor: renderedCellValue == 'Z' ? '#c769c7' : renderedCellValue == 'P' ? '#ffc4ab' : renderedCellValue == 'S' || renderedCellValue == null  ? '#7edeed' : renderedCellValue == 'A' ? '#ebe7b2' : renderedCellValue == 'V' ? '#59d970' : '#003366'  }}>{rotuloEnviado(renderedCellValue)}</Badge>
                <Badge style={{  backgroundColor: corEnviado(renderedCellValue) }}>{rotuloEnviado(renderedCellValue)}</Badge>
                
           
            ),
          },


          {
            accessorKey: 'dataEnvio',
            header: 'Enviado em',
          },


          {
            accessorKey: 'dataHoraUltimaAuditoria',
            header: 'Última auditoria em',
          },
         


         
         

        ],
        [],
      );


    async function geraExcel() {

        

        window.toastr.success('Aguarde, gerando XLSX...')

        await api.get('geraExcelCompras/0').then((result) => {

            

            if (result.data.alerta == 'ok') {

                sleep(1000).then(() => {

                    //window.open(`http://apihomolog.hospitaissaudaveis.org/residuosSS.xlsx`)
                    //window.location.href = `http://172.16.1.253:3600/${result.data.arquivo}`
                    window.location.href = `${process.env.REACT_APP_API}/${result.data.arquivo}`

                })
                
            }

        }).catch((err) => {

            console.log(err.response)

        })

    }


    async function carregaAnos() {

        var anoTemp = []

        var anoAtual = new Date().getFullYear()

        for (var x = anoAtual; x >= 2008; x--) {

            var anoJson = {

                ano: x,

            }

            anoTemp.push(anoJson)

        }

        setAnos(anoTemp.map((rs) =>
        
            <option value={rs.ano}>{rs.ano}</option>
        
        ))

    }


    async function preenchimentos(adesao_institucional_id_ref) {

        
        if (adesao_institucional_id_ref == null) { adesao_institucional_id_ref = 0 }



        var dataPost = {

            regiao: regiao,
            uf: uf,
  
        }

        setCarregando('block')

        await api.post(`/comprasListaPendencias/${adesao_institucional_id_ref}/${ano}`, dataPost).then((result) => {

            //console.log(result.data, '!!')

            setTotalPreenchimentos(result.data.length)

            setResultadoPend(result.data)

            /*
            setResultadoPend(result.data.map((rs) => {

                return {

                    nome_fantasia: rs.nome_fantasia,
                    cnpj: rs.cnpj,
                    situacaoPerfilAnual: rotulo(rs.situacaoPerfilAnual),
                    secaoI: rotulo(rs.secaoI),
                    secaoII: rotulo(rs.secaoII),
                    secaoIII: rotulo(rs.secaoIII),
                    secaoIV: rotulo(rs.secaoIV),
                    dataEnvio: rs.dataEnvio,
                    situacaoEnviado: rotuloEnviado(rs.situacaoEnviado),
                    dataEnvio: rs.dataEnvio,
                    dataUltimoPreenchimento: rs.dataUltimoPreenchimento,
                    adesao_institucional_id: rs.adesao_institucional_id,
                    anoDesafio: rs.anoDesafio,
                    compras_id: rs.compras_id,
                    clickEvent: () => { setAno(rs.anoPerfil ? rs.anoPerfil : rs.anoDesafio); setAdesaoInstitucionalId(rs.adesao_institucional_id); setCompras_id(rs.compras_id); window.$("#modalCompras").modal('show');}
                    
                }

            }))
            */

            setCarregando('none')
            

        }).catch((err) => {

            console.log(err)
            setCarregando('none')

        })


    }



    const correcoes = () => {

        var dataPost = {

            desafio: 'Compras'

        }

        api.post('desafioValidaCorrecoes', dataPost).then((result) => {

            setResultadoCorrecoes(result.data)
            setTotalCorrecoes(result.data.length)

        }).catch((err) => {

            console.log(err.response)

        })


    }



  const carregaRegiao = () => {

    api.get('regiao').then((result) => {

        setResultadoRegiao(result.data.map((rs) =>
                
            <option value={rs.regiao}>{rs.regiao}</option>
    
        ))

    }).catch((err) => {

        console.log(err.response)

    })

}


const carregaUF = () => {

    api.get('uf').then((result) => {

        //console.log(result.data)

        setResultadoUF(result.data.map((rs) =>
                
            <option value={rs.uf_codigo}>{rs.uf_codigo}</option>
    
        ))

    }).catch((err) => {

        console.log(err.response)

    })

}


    const verificados = () => {

        var dataPost = {

            desafio: 'Compras'

        }

        api.post('desafioValidaVerificados', dataPost).then((result) => {

            console.log(result.data, 'verificados')

            setResultadoVerificados(result.data)
            setTotalVerificados(result.data.length)

        }).catch((err) => {

            console.log(err.response)

        })


    }


    const abreCertificado = async (dataPost) => {

        

        api.post('certificado', dataPost).then((result) => {

            window.toastr.info('Aguarde...')
            
            if (result.data.arquivo) {

                sleep(1000).then(() => {

                    window.open(`${process.env.REACT_APP_API}/pdf/${result.data.arquivo}`)

                })

            }

        }).catch((err) => {

            console.log(err.response)

        })

    }



    useEffect(() => { 

        carregaRegiao()
        carregaUF()
        carregaAnos()
        carregaRede()
        carregaDados()
        

    }, [])



    useEffect(() => {

        //console.log(ano)
        preenchimentos(adesao_institucional_id_ref)
        correcoes()
        verificados()

    }, [ano, uf, regiao, verificaDesafio])



    return (

        <div>
             <div class='content-header'>
                <div class='header-icon'>
                    <i class='pe-7s-gleam'></i>
                </div>
                <div class='header-title'>
                    <h1>Desafio Compras</h1>
                    <small>Administração</small>
                    
                </div>
            </div>


            <ul className="nav nav-tabs">
                <li ><a href="#tab1" data-toggle="tab">Adesões ({totalAdesoes})</a></li>
                <li className="active" ><a href="#tab2" data-toggle="tab" onClick={() => {} } >Preenchimentos ({totalPreenchimentos})</a></li>
                <li ><a href="#tab3" data-toggle="tab" onClick={() => {} } >Correções ({totalCorrecoes})</a></li>
                <li ><a href="#tab4" data-toggle="tab" onClick={() => {} } >Verificados ({totalVerificados})</a></li>
                <li ><a href="#tab5" data-toggle="tab" onClick={() => {} } >Notificações ({totalNotificacoes})</a></li>
                
                
            </ul>

            <div class="tab-content">
                <div class="tab-pane fade in " id="tab1">
                    <div class="panel-body">


                        <div class="col-md-12">

                            <br/>

                            <button type="button" class="btn btn-success" onClick={() => geraExcel()}>Exportar XLS</button>&nbsp;
                            <br/><br/>




                            <MaterialReactTable 

                                columns={columnsR} 
                                data={resultado} 
                                localization={MRT_Localization_PT_BR}
                                //rowsPerPage={20}
                                //options={options}
                                initialState={{ density: 'compact' }}
                                muiTableHeadCellProps={{
                                    //easier way to create media queries, no useMediaQuery hook needed.
                                    sx: {
                                    fontSize: {
                                        xs: '8px',
                                        sm: '9px',
                                        md: '10px',
                                        lg: '11px',
                                        xl: '12px',
                                    },
                                    },
                                }}
                                muiTableBodyCellProps={{
                                    sx: {
                                        fontSize: {
                                        xs: '8px',
                                        sm: '9px',
                                        md: '10px',
                                        lg: '11px',
                                        xl: '12px',
                                        },
                                    },
                                }}
                                muiTableBodyRowProps={({ row }) => ({
                                onClick: (event) => {
                                    //console.info(event, row.original.usuario_id);
                                    //navigate(`/FluxoCaixa/Vinculo/${row.original.vinculo_id}`)
                                    //window.$('.modal-MovimentoEdit').modal('show');setMovimento_id(row.original.movimento_id)
                                    //history.push(`AdesaoInstitucional/${row.original.adesao_institucional_id}`)
                                    //setAno(row.original.anoPerfil ? row.original.anoPerfil : row.original.anoDesafio); setAdesaoInstitucionalId(row.original.adesao_institucional_id); setResiduo_id(row.original.residuo_id); window.$("#modalResiduos").modal('show')
                                    //setAno(row.original.anoPerfil ? row.original.anoPerfil : row.original.anoDesafio); setAdesaoInstitucionalId(row.original.adesao_institucional_id); setCompras_id(row.original.compras_id); window.$("#modalCompras").modal('show')
                                    history.push(`AdesaoInstitucional/${row.original.adesao_institucional_id}`)
                                },
                                sx: {
                                    cursor: 'pointer', //you might want to change the cursor too when adding an onClick
                                },
                                })}
                                />

                            


                        </div>


                        


                    </div>
                </div>

                <div className="tab-pane fade in" id="tab3">
                    <div class="panel-body">



                          <div className="col-md-12" style={{ display: carregando }} >
                          <LoaderIcon  type={"cylon"} style={{ display: carregando }} />
                          </div>

                          <div className="col-md-12" style={{ display: carregando == 'none' ? 'block' : 'none'}}>




                            <MaterialReactTable 

                            columns={columnsCorrecoes} 
                            data={resultadoCorrecoes} 
                            localization={MRT_Localization_PT_BR}
                            //rowsPerPage={20}
                            //options={options}
                            initialState={{ density: 'compact' }}
                            muiTableHeadCellProps={{
                                //easier way to create media queries, no useMediaQuery hook needed.
                                sx: {
                                fontSize: {
                                    xs: '8px',
                                    sm: '9px',
                                    md: '10px',
                                    lg: '11px',
                                    xl: '12px',
                                },
                                },
                            }}
                            muiTableBodyCellProps={{
                                sx: {
                                    fontSize: {
                                    xs: '8px',
                                    sm: '9px',
                                    md: '10px',
                                    lg: '11px',
                                    xl: '12px',
                                    },
                                },
                            }}
                            muiTableBodyRowProps={({ row }) => ({
                            onClick: (event) => {
                                //console.info(event, row.original.usuario_id);
                                //navigate(`/FluxoCaixa/Vinculo/${row.original.vinculo_id}`)
                                //window.$('.modal-MovimentoEdit').modal('show');setMovimento_id(row.original.movimento_id)
                                //history.push(`AdesaoInstitucional/${row.original.adesao_institucional_id}`)
                                //setAno(row.original.anoPerfil ? row.original.anoPerfil : row.original.anoDesafio); setAdesaoInstitucionalId(row.original.adesao_institucional_id); setResiduo_id(row.original.residuo_id); window.$("#modalResiduos").modal('show')
                                setAnoProps(row.original.anoPerfil ? row.original.anoPerfil : row.original.anoDesafio); setAdesaoInstitucionalId(row.original.adesao_institucional_id); setCompras_id(row.original.compras_id); window.$("#modalCompras").modal('show')
                            },
                            sx: {
                                cursor: 'pointer', //you might want to change the cursor too when adding an onClick
                            },
                            })}
                            />

                            </div>


                    </div>
                </div>
                <div className="tab-pane fade in" id="tab5">

                    <Pendencias
                        desafio="Compras"
                        setTotalNotificacoes={setTotalNotificacoes}
                        abrirModal={(item) => {

                            setAdesaoInstitucionalId(
                                item.adesao_institucional_id
                            )

                            setCompras_id(
                                item.compras_id ??
                                item.formulario_id
                            )

                            setAnoProps(
                                item.anoPerfil ??
                                item.anoDesafio ??
                                item.ano
                            )

                            window.$(
                                '#modalCompras'
                            ).modal('show')

                        }}
                    />

                </div>
                <div className="tab-pane fade in" id="tab4">

                    <div className="panel-body">

                        <div className="col-md-12" style={{ display: carregando }} >
                            <LoaderIcon  type={"cylon"} style={{ display: carregando }} />
                        </div>
                            
                        <div className="col-md-12" style={{ display: resultadoVerificados ? 'block' : 'none'}}>

                            <MaterialReactTable 

                                columns={columnsVerificados} 
                                data={resultadoVerificados} 
                                localization={MRT_Localization_PT_BR}
                                //rowsPerPage={20}
                                //options={options}
                                initialState={{ density: 'compact' }}
                                muiTableHeadCellProps={{
                                    //easier way to create media queries, no useMediaQuery hook needed.
                                    sx: {
                                    fontSize: {
                                        xs: '8px',
                                        sm: '9px',
                                        md: '10px',
                                        lg: '11px',
                                        xl: '12px',
                                    },
                                    },
                                }}
                                muiTableBodyCellProps={{
                                    sx: {
                                        fontSize: {
                                        xs: '8px',
                                        sm: '9px',
                                        md: '10px',
                                        lg: '11px',
                                        xl: '12px',
                                        },
                                    },
                                }}
                                muiTableBodyRowProps={({ row }) => ({
                                onClick: (event) => {
                                    
                                    //setAno(row.original.anoPerfil ? row.original.anoPerfil : row.original.anoDesafio); setAdesaoInstitucionalId(row.original.adesao_institucional_id); 
                                    //setHospClima_id(row.original.hospClima_id); window.$("#modalCertificado").modal('show')

                                    abreCertificado({

                                        ano: row.original.anoPerfil ? row.original.anoPerfil : row.original.anoDesafio,
                                        adesao_institucional_id: row.original.adesao_institucional_id,
                                        formulario_id: row.original.residuo_id,
                                        certificacao: row.original.certificacao,
                                        origem: 'Compras',

                                    })

                                },
                                sx: {
                                    cursor: 'pointer', //you might want to change the cursor too when adding an onClick
                                },
                                })}

                            />


                        </div>

                    </div>

                </div>
                <div className="tab-pane fade in active" id="tab2">
                    <div class="panel-body">


                    <div class="col-md-12">


                        <button type="button" class="btn btn-success" onClick={() => geraExcelPend()} >Exportar XLS</button>&nbsp;
                        <br/>


                    </div>

                    <div className="col-md-12">

                        <div className="form-group">

                            <br/>
                            
                            <select style={{ backgroundColor: '#f0f9fa'}} className="form-control" onChange={event => {preenchimentos(event.target.value);setAdesaoInstitucionalIdRef(event.target.value)}} value={adesao_institucional_id_ref} >
                                <option value="0">[Rede ou Sistema de Saúde]</option>
                                {resultadoRede}
                            </select>  
                            
                        </div>

                        </div>

                        <div className="col-md-4">
                              <div className="form-group">

                                  
                                  
                                  <select style={{ backgroundColor: '#f0f9fa'}} className="form-control" onChange={event => {setAno(event.target.value)}} value={ano} >
                                      <option value={0}>Todos os anos</option>
                                      {anos}
                                  </select>  
                                  
                              </div>
                          </div>
                          <div className="col-md-4">
                              <div className="form-group">

                                  
                                  <select style={{ backgroundColor: '#f0f9fa'}} className="form-control" onChange={event => {setUF(event.target.value)}} value={uf} >
                                      <option value="">[UF]</option>
                                      {resultadoUF}
                                  </select>  
                                  
                              </div>
                          </div>
                          <div className="col-md-4">
                              <div className="form-group">

                                  
                                  <select style={{ backgroundColor: '#f0f9fa'}} className="form-control" onChange={event => {setRegiao(event.target.value)}} value={regiao} >
                                      <option value="">[Região]</option>
                                      {resultadoRegiao}
                                  </select>  
                                  
                              </div>
                          </div>

                          <div className="col-md-12" style={{ display: carregando }} >
                          <LoaderIcon  type={"cylon"} style={{ display: carregando }} />
                          </div>

                          <div className="col-md-12" style={{ display: carregando == 'none' ? 'block' : 'none'}}>


                                <MaterialReactTable 

                                columns={columns} 
                                data={resultadoPend} 
                                localization={MRT_Localization_PT_BR}
                                //rowsPerPage={20}
                                //options={options}
                                initialState={{ density: 'compact' }}
                                muiTableHeadCellProps={{
                                    //easier way to create media queries, no useMediaQuery hook needed.
                                    sx: {
                                    fontSize: {
                                        xs: '8px',
                                        sm: '9px',
                                        md: '10px',
                                        lg: '11px',
                                        xl: '12px',
                                    },
                                    },
                                }}
                                muiTableBodyCellProps={{
                                    sx: {
                                        fontSize: {
                                        xs: '8px',
                                        sm: '9px',
                                        md: '10px',
                                        lg: '11px',
                                        xl: '12px',
                                        },
                                    },
                                }}
                                muiTableBodyRowProps={({ row }) => ({
                                onClick: (event) => {
                                    //console.info(event, row.original.usuario_id);
                                    //navigate(`/FluxoCaixa/Vinculo/${row.original.vinculo_id}`)
                                    //window.$('.modal-MovimentoEdit').modal('show');setMovimento_id(row.original.movimento_id)
                                    //history.push(`AdesaoInstitucional/${row.original.adesao_institucional_id}`)
                                    //setAno(row.original.anoPerfil ? row.original.anoPerfil : row.original.anoDesafio); setAdesaoInstitucionalId(row.original.adesao_institucional_id); setResiduo_id(row.original.residuo_id); window.$("#modalResiduos").modal('show')
                                    setAnoProps(row.original.anoPerfil ? row.original.anoPerfil : row.original.anoDesafio); setAdesaoInstitucionalId(row.original.adesao_institucional_id); setCompras_id(row.original.compras_id); window.$("#modalCompras").modal('show')

                                },
                                sx: {
                                    cursor: 'pointer', //you might want to change the cursor too when adding an onClick
                                },
                                })}
                                />

                            </div>



                    </div>

                </div>

            </div>

            

            <ModalCompras adesao_institucional_id={adesao_institucional_id} ano={anoProps} formulario_id={compras_id} compras_id={compras_id} />
            <ModalValidacao adesao_institucional_id={adesao_institucional_id} ano={anoProps} formulario_id={compras_id} origem='Compras' correcoes={correcoes} />
            <ModalEmailCorrecao adesao_institucional_id={adesao_institucional_id} ano={anoProps} formulario_id={compras_id} origem='Compras' correcoes={correcoes} />
            <ModalEmailVer desafioEmail_id={desafioEmail_id}  />

        </div>

    )

}


export default Compras